import { Box } from '@chakra-ui/react'
import { createColumnHelper } from '@tanstack/react-table'
import { truncate } from 'lodash'
import { IoIdCard } from 'react-icons/io5'
import { getDateTimeReadFormat } from 'shared/utils/dateFormatting'
import { EmptyCell } from 'uikit/ReactTable/cells/EmptyCell'
import { ItemBadge, ItemIcon } from 'uikit/Snippets'
import { bannerIdentification, bannerIdentificationTitle } from '../Banners.constants'

type Banner = {
  id: string
  group: string
  subject: string
  identifications: Array<{ id: string; identificationState: ValueOf<typeof bannerIdentification> }>
  body: string
  isActive: number
  start: string
  end: string
  createDate: string
  updateDate: string
}

const columnHelper = createColumnHelper<Banner>()

export const columns = [
  columnHelper.accessor('id', {
    header: '',
    cell: () => <ItemIcon w="60px" IconComponent={IoIdCard} badge={null} />,
    minSize: 60,
    maxSize: 60,
    enableHiding: false,
  }),
  columnHelper.accessor('group', {
    header: 'Группа',
    minSize: 120,
    maxSize: 200,
    cell: (info) => info.getValue() || <EmptyCell />,
    enableSorting: true,
  }),
  columnHelper.accessor('subject', {
    header: 'Тема',
    minSize: 200,
    maxSize: 250,
    cell: (info) => info.getValue() || <EmptyCell />,
  }),
  columnHelper.accessor('identifications', {
    header: 'Группа пользователей',
    minSize: 200,
    maxSize: 280,
    cell: (info) => {
      const identifications = info.getValue()
      return identifications?.length ? (
        identifications
          .map((item) => bannerIdentificationTitle[item?.identificationState])
          .join(', ')
      ) : (
        <Box color="gray.300">пусто</Box>
      )
    },
  }),
  columnHelper.accessor('body', {
    header: 'Сообщение',
    minSize: 280,
    maxSize: 400,
    cell: (info) => truncate(info.getValue(), { length: 200 }) || <EmptyCell />,
  }),
  columnHelper.accessor('isActive', {
    header: 'Активность',
    minSize: 100,
    maxSize: 150,
    cell: (info) => (
      <ItemBadge colorPalette={info.getValue() === 1 ? 'green' : 'gray'}>
        {info.getValue() === 1 ? 'Активно' : 'Неактивно'}
      </ItemBadge>
    ),
  }),
  columnHelper.accessor('start', {
    header: 'Старт',
    minSize: 150,
    maxSize: 200,
    cell: (info) => getDateTimeReadFormat(info.getValue()) || <EmptyCell />,
  }),
  columnHelper.accessor('end', {
    header: 'Финиш',
    minSize: 150,
    maxSize: 200,
    cell: (info) => getDateTimeReadFormat(info.getValue()) || <EmptyCell />,
  }),
  columnHelper.accessor('createDate', {
    header: 'Дата создания',
    minSize: 150,
    maxSize: 200,
    cell: (info) => getDateTimeReadFormat(info.getValue()) || <EmptyCell />,
    enableSorting: true,
  }),
]

